/**
 * 1. AccommodationPicking - Enter daterange, and pick an accommodation
 * 2. AccommodationReserving - Reserve the picked accommodation, entering extra services, people etc...
 * 3. HolderAndPaymentInfo - Enter reservation holder information & payment information
 * 4. ReservationOverview - Overview before final confirmation
 * 5. Pay/Thank you screen ? - to be confirmed
 */

export enum AppPage {
  AccommodationPicking = "accommodationPicking",
  ExtraOptions = "extraOptions",
  HolderAndPaymentInfo = "holderAndPaymentInfo",
  ReservationOverview = "reservationOverview",
  PaymentResult = "paymentResult",
}
